var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFleet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 90,
    viewBox: "0 0 152 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2328 18.7409C86.9007 18.5715 66.0744 18.0775 64.4621 18.2045C64.4621 18.2045 63.1609 9.16337 62.5385 6.44609C62.3052 5.43681 61.6546 2.21136 60.8908 0.559814H53.6069C52.7512 2.70541 52.0299 5.83911 51.7753 7.06013C51.153 10.0315 50.3893 15.2967 49.9508 18.2045C49.9508 18.2045 30.949 18.6351 27.3565 18.7903C26.6564 18.8186 12.3856 19.2138 0.420227 20.7454V25.453C10.7945 26.8645 32.1936 26.9492 37.3065 26.9916C39.0391 27.0057 50.3256 26.9916 50.8206 26.9916C50.8206 26.9916 51.6551 34.6706 55.0778 45.575H59.4411C60.9191 40.451 62.185 35.6022 63.4649 26.8645C63.4649 26.8645 80.5644 26.8645 86.8937 26.8645C94.7221 26.8645 106.751 26.5117 114.099 25.2765V20.9783C108.265 19.842 96.3415 18.875 92.2258 18.7409H92.2328Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.450594,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 62.809C124.034 62.6396 103.207 62.1456 101.595 62.2726C101.595 62.2726 100.294 53.2315 99.6713 50.5142C99.438 49.5049 98.7874 46.2795 98.0236 44.6279H90.7397C89.884 46.7735 89.1627 49.9072 88.9081 51.1282C88.2858 54.0996 87.5221 59.3648 87.0836 62.2726C87.0836 62.2726 68.0818 62.7032 64.4894 62.8584C63.7893 62.8867 49.5185 63.2819 37.553 64.8135V69.5211C47.9273 70.9327 69.3264 71.0174 74.4393 71.0597C76.1719 71.0738 87.4584 71.0597 87.9534 71.0597C87.9534 71.0597 88.7879 78.7387 92.2106 89.6431H96.5739C98.0519 84.5191 99.3178 79.6703 100.598 70.9327C100.598 70.9327 117.697 70.9327 124.026 70.9327C131.855 70.9327 143.884 70.5798 151.232 69.3446V65.0464C145.397 63.9101 133.474 62.9431 129.359 62.809H129.366Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.450594,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleet);
export default __webpack_public_path__ + "static/media/Fleet.9b0b4567.svg";
export { ForwardRef as ReactComponent };